import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './style.css';

export default class InsetSection extends React.Component {
  
  render() {
    const clazz = classNames( style.insetSection, this.props.className );
    return (
      <div className={clazz} {...this.props}>
        {this.props.children}
      </div>
    )
  }
}
